var path = 'msi/subscriptions/pause/pause-button.html';
var html = "<a ui-sref=\"pause({ subscription: $ctrl.subscription })\" href=\"javascript:void(0);\">\n  {{'PAUSE_SUBSCRIPTION_BUTTON' | translate}}\n</a>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;